module.exports = __webpack_public_path__ + "img/mobilethingsBanner.cf3e08d7.png";